import { Text } from '@amo/core/components/forms';
import { Field } from 'redux-form';
import {getTranslation} from "@amo/core/utils/index.js";

const CodePromo = (props) => {
    const { postFill, loading, codePromo, formuleCodePromoEligible, formuleMessageEligibleCodePromo } = props;

    return (
        <div id="promo" className={`row mt-2 m-lg-5 pb-4`}>
            <div className={'col-12 col-xl-8 col-lg-8 col-md-6 col-sm-6 offset-xl-2 offset-lg-2 offset-md-3 offset-sm-3'}>
                <div className={'row align-items-center'}>
                    <div className="col-12 col-xl-5 col-lg-6">
                        <p className={'d-block d-sm-none f-20 text-dark fw-bold text-start'} dangerouslySetInnerHTML={{__html: getTranslation('pricing.promoCode.titleDesktop')}}/>
                        <p className={'d-none d-sm-block f-20 text-dark fw-bold text-start'} dangerouslySetInnerHTML={{__html: getTranslation('pricing.promoCode.titleMobile')}}/>
                    </div>

                    <div className="col-12 col-xl-7 col-lg-6 col-md-6 mt-3 mt-lg-0">
                        <div className="row align-items-center">
                            <div className="col-sm-8 col-12">
                                <Field
                                    component={Text}
                                    name={'DemandeTarif[CodePromo][CodePromo]'}
                                    label={getTranslation('pricing.promoCode.label')}
                                />
                            </div>
                            <div className="col-12 col-sm-4">
                                <button
                                    type="button"
                                    className={'btn btn-outline-primary fw-normal py-2 f-13 w-100'}
                                    onClick={() => postFill({ codePromo: true })}
                                    style={{ height: 50, marginTop: 24, lineHeight: '32px' }}
                                    disabled={loading}
                                    aria-label={getTranslation('pricing.promoCode.validate') || 'Valider le code promo'}
                                >
                                    {loading ? (
                                        <span
                                            className="spinner-border spinner-border-sm"
                                            role="status"
                                            aria-hidden="true"
                                        ></span>
                                    ) : (
                                        getTranslation('validate')
                                    )}
                                </button>
                            </div>
                        </div>
                        {codePromo && !formuleCodePromoEligible && formuleMessageEligibleCodePromo && (
                            <p className={'text-danger f-14 text-start'}>{getTranslation('pricing.promoCode.error')}</p>
                        )}
                        {codePromo?.Eligible && formuleCodePromoEligible && formuleMessageEligibleCodePromo && (
                            <p className={'text-success f-14 text-start'}>{getTranslation('pricing.promoCode.success')}</p>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CodePromo;
